export default "__VITE_ASSET__CPndn$$R__"